import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import EnterpriseLearningPathPageDirector from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseLearningPathPageDirector';
import NotFound from 'bundles/phoenix/components/NotFound';
import UnifiedUserExperienceHandler from 'bundles/unified-common/providers/UnifiedUserExperienceHandler';
import EnterprisePageWrapper from 'bundles/unified-description-page-common/pages/enterprise/EnterprisePageWrapper';

const EnterprisePageWrapperWithUserExperienceHandler = (props: React.ComponentProps<typeof EnterprisePageWrapper>) => (
  <UnifiedUserExperienceHandler>
    <EnterprisePageWrapper {...props} />
  </UnifiedUserExperienceHandler>
);

export default (
  <Route>
    <CourseraRoute
      name="enterprise"
      path="/programs/:programSlug"
      component={EnterprisePageWrapperWithUserExperienceHandler}
      handle={{
        tracking: {
          segment: 'enterprise',
          data: (params) => {
            return {
              enterprise: {
                programSlug: params.programSlug,
              },
              page: {
                slug: params.badgeTemplateSlug,
              },
            };
          },
        },
      }}
    >
      <CourseraRoute
        name="enterprise-learning-path"
        path="learning-path/:badgeTemplateSlug"
        component={EnterpriseLearningPathPageDirector}
        handle={{
          tracking: {
            data: () => ({
              page: {
                type: 'xdp_learning_path',
              },
            }),
          },
        }}
      />
    </CourseraRoute>
    <Route path="*" component={NotFound} />
  </Route>
);
